// @react/hooks/useFiscalizationShift.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { fiscalizationShiftStore } from '@core/stores';

/**
 * React hook for FiscalShift operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useFiscalizationShift } from '@react/hooks';
 *
 * const FiscalShiftList = observer(() => {
 *   const store = useFiscalizationShift();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useFiscalizationShift() {
  return fiscalizationShiftStore;
}
